export const environment = {
  production: true,
  recaptchaKey: '6LcG-GMpAAAAAHsTtSAqZxz_3hrMqyfaBx0pxhO5',
  mapToken:
    'eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjRNOTZNUjIzUTMifQ.eyJpc3MiOiJQQTk3WkZUREM5IiwiaWF0IjoxNzE0Mjg0NjU5LCJleHAiOjE3MzU2MDMyMDAsIm9yaWdpbiI6Imh0dHBzOi8vcWEuYWxwaGF0cmFuc2ZlcnMuY29tLm14In0.DPMuxQIFtrnLQ-Y0Ah0dA4YFHXLVMCZFchEtrsPhlaO6EYbERHYzsRttT3dqj6rRr12mC5tPfOnr88qttOynvQ',
  apiUrl: 'https://api.amidmcloscabos.com/back',
  apiUrlAlpha: 'https://api.amidmcloscabos.com/api',
};
